<ng-container *nzStringTemplateOutlet="placeholder">
  {{ placeholder }}
</ng-container>
